export class ScreenSizeTracker {
  screenWidth: number;
  screenHeight: number;
}
